




































  import { EventBus } from "../event-bus";
  import axios from "axios";
  import { Component, Prop, Vue } from "vue-property-decorator";
  import {UsbStatusModel} from "@/models/UsbStatus";

  @Component({
    components: {
    },
    
})

export default class UsbStatus extends Vue {
//there is a button in the header. it appears(showUbStatusInfo) only if a usb creation is in progress.
//when it is pressed, it sends a changeUsbStatusModal,true signal to the DeviceListing.
//the DeviceListing picks up the button's signal and shows the dialog (usbStatusModalFlag).
//similarilly also if File is visible picks up the signal and shows the dialog.
    @Prop() firstUsbStatus!:UsbStatusModel;
    public usbStatus:UsbStatusModel=new UsbStatusModel;
    public messages=[
        {message:"Create Linux User in server",index:1,color:"red",},
        {message:"Create personal Linux image",index:2,color:"red",},
        {message:"Partition the usb",index:3,color:"red",},
        {message:"Format the usb",index:4,color:"red",},
        {message:"Transfer files to the usb",index:5,color:"red",},
    ];
    public delayFlag=false;
   
    private setDelayFlag(value:boolean){
      this.delayFlag=value;
    }
    /*public delay = (time:number) => {
      setTimeout(() =>{
        this.setDelayFlag(false);
        console.log("delay finished UsbStatus");
      },time); //delay is in milliseconds 
    } */

    created() {
        this.usbStatus=this.firstUsbStatus;
        this.setColors(this.usbStatus);
        EventBus.$on("refreshUsbStatus", (value: UsbStatusModel) => {
          //state 1: proccess running, continually update. Set dots.
          //state 2: error or finished :proccess created result. Start delay, set dots and message.
          //state 3: We are on a delay and a new proccess started: proccess restate. stop delay, set dots.

          /*
          Running | CFFinished  | delayFlag | state
          100     | true        | true      | 3 (check delay)
          100     | true        | false     | 2 (set delay)
          100     | false       | true      | 3 (check delay) status.running==anything but value.running==100
          100     | false       | false     | 1 (check result)
          200     | any         | any       | -
          400     | false       | true      | 3 (check delay) status.running==400 but value.running==100/200
          400     | false       | false     | 2 (set delay)
          */
          if (value.Running==100 && !value.CheckFileFinished && !this.delayFlag){
            this.usbStatus = value;
            this.setColors(value);   
          }
          if ((value.CheckFileFinished || value.Running==400) && !this.delayFlag){
            this.usbStatus = value;
            this.setColors(value);            
            this.delayFlag=true;
            console.log("delay started usbStatus")
          }
          else if (value.Running==100 && this.delayFlag){
            this.delayFlag=false;
            this.usbStatus = value;
            this.setColors(value); 
            console.log("delay finished UsbStatus");
          }

          /*
          if (!this.delayFlag){
              this.usbStatus = value;
              this.setColors(value);
          }
          if(value.Running==100 && (this.usbStatus.CheckFileFinished || this.usbStatus.Running==400)){
              this.usbStatus = value;
              this.setColors(value);
          }

          if (value.Error!=undefined || value.CheckFileFinished){
            this.delayFlag=true;
            this.setDelayFlag(false);//secTime*numOfSecs
            console.log("delay started usbStatus")

          }
          */
            
            //100 running //400 error //200 not running
        });
    }

    public setColors(value: UsbStatusModel){
      value.CreateUserFinished ? this.messages[0].color="green":this.messages[0].color="red";
      value.SquashFileFinished ? this.messages[1].color="green":this.messages[1].color="red";
      value.FormatDeviceFinished ? this.messages[2].color="green":this.messages[2].color="red";
      value.LoadImageFinished ? this.messages[3].color="green":this.messages[3].color="red";
      value.CheckFileFinished ? this.messages[4].color="green":this.messages[4].color="red";

    }
}
